<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}">
  <div class="doc-paper preview keirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="keirekisho-wapper">
      <div class="keirekisho-header" style="text-align: left">
<!--        <h1 class="title">경력기술서</h1>-->
<!--        <div class="date data text-right"-->
<!--               :data-highlight="highlightMessage"-->
<!--               @click="goCardTo('create-date')"-->
<!--               :class="highLightClass('create-date')">-->
<!--          <span v-html="formatedCreateDate"></span>-->
<!--        </div>-->

          <div class="flex" style='display:flex;'>
              <div class="rirekisho-box1">
                  <div class="rirekisho-header">
                      <div class="title" style="border-bottom:0px">경력기술서</div>
                      <div class="date"
                           @click="goCardTo('create-date')"
                           :class="highLightClass('create-date')">
                          <span v-html="formatedCreateDate"></span>
                      </div>
                  </div>
                  <div class="rirekisho-profile"
                       :data-highlight="highlightMessage"
                       @click="goCardTo('profile')"
                       :class="highLightClass('profile')">

                      <div class="name flex" style="display: flex;border-top: dotted 0px #000;">
                          <div class="label">성명</div>
                          <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
                      </div>
                      <div class="etc flex" style='display:flex;'>
                          <div class="birthday" :style="formatData.selFontStyle">
                              <span class="year">{{ basicData.birthYear }}</span>년 <span class="month">{{ basicData.birthMonth }}</span>월 <span class="day">{{ basicData.birthDay }}</span>일（만 <span class="age">{{ age }}</span> 세）
                          </div>

                          <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">남</span><span v-if="!isGenderDisplay">・</span>
                              <span class="female" v-if="!isGenderDisplay"
                                    v-bind:class="{'preview-is-checked': isFemale}">여</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="rirekisho-photo"
                   :data-highlight="highlightMessage"
                   @click="goCardTo('id-photo')"
                   :class="highLightClass('id-photo')">
                  <div v-if="basicData.idPhotoSrc">
                      <img :src="basicData.idPhotoSrc"
                           alt="증명사진">
                  </div>
                  <div v-else>
                      <div class="rirekisho-photo-inner">
                          <p>증명사진
                              <br>세로 36mm&#12316;40mm
                              <br>가로 24mm&#12316;30mm
                          </p>
                      </div>
                  </div>
              </div>
          </div>
          <div class="rirekisho-box2">
              <div class="contact-information contact-main flex" style='display:flex;'>
                  <div class="contact-information-address"
                       :data-highlight="highlightMessage"
                       @click="goCardTo('address')"
                       :class="highLightClass('address')">

                      <div class="address flex" style="display:flex;border-top: dotted 0px #000;">
                          <div class="label">주소</div>
                          <div class="input">
                              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
                              <pre :style="formatData.selFontStyle" style="line-height:1.4" >{{ basicData.address1}}
{{ basicData.address2 }}</pre>
                          </div>
                      </div>
                  </div>
                  <div class="contact-information-etc"
                       :data-highlight="highlightMessage"
                       @click="goCardTo('contacts')"
                       :class="highLightClass('contacts')">
                      <div class="tel flex" style='display:flex;'>
                          <div class="label">전화</div>
                          <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
                      </div>
                      <div class="email flex" style='display:flex;'>
                          <div class="label">Email</div>
                          <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
                      </div>
                  </div>
              </div>
              <div class="contact-information contact-sub flex">
                  <div class="contact-information-address"
                       @click="goCardTo('address')"
                       :class="highLightClass('address')">

                      <!--          <div class="address flex">-->
                      <!--            <div class="label">연락처</div>-->
                      <!--            <div class="input">-->
                      <!--              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.contactPostNumber) }}</div>-->
                      <!--              <div class="comment">(현주소 이외에 연락을 원하는 경우에만 입력)</div>-->
                      <!--              <pre :style="formatData.selFontStyle">{{ basicData.contactAddress1 }}-->
                      <!--{{ basicData.contactAddress2 }}</pre>-->
                      <!--              <div class="care-of"-->
                      <!--                   v-if="basicData.contactCareOf" :style="formatData.selFontStyle">{{ basicData.contactCareOf }} 方</div>-->
                      <!--            </div>-->
                      <!--          </div>-->
                  </div>

              </div>
          </div>



      </div>
      <div class="keirekisho-content">
        <h2 v-if="formatData.jobSummary">업무요약</h2>
        <div class="job-summary"
             :data-highlight="highlightMessage"
             @click="goCardTo('job-summary')"
             :class="highLightClass('job-summary')">
          <pre :style="formatData.selFontStyle">{{ formatData.jobSummary }}</pre>
        </div>
        <h2 v-if="formatData.skillsToUse&&formatData.skillsToUse.length" id="skills">스킬</h2>
        <div class="skills-to-use"
             :data-highlight="highlightMessage"
             @click="goCardTo('skills-to-use')"
             :class="highLightClass('skills-to-use')">
          <dl v-for="(item, index) in formatData.skillsToUse"
              :key="index" :style="formatData.selFontStyle">
            <dt>{{ item.skillname }} <template v-if="item.years">/ 실무경험 {{ item.years }}년이상</template></dt>
            <dd>{{ item.description }}</dd>
          </dl>
        </div>
        <h2 v-if="formatData.jobHistories&&formatData.jobHistories.length" id="job-history">업무경력</h2>
        <div class="job-history"
             :data-highlight="highlightMessage"
             @click="goCardTo('job-history')"
             :class="highLightClass('job-history')">
          <div v-for="item in formatData.jobHistories"
               :key="item.uuid">
            <h3 v-if="item.companyName || item.startYear || item.startMonth || item.endYear || item.endMonth" class="company-name" :style="formatData.selFontStyle">{{ item.companyName }}
              <span v-if="item.isContinuing && item.startYear && item.startMonth">{{ item.startYear}}년 {{ item.startMonth }}월 〜 재직중</span>
              <span v-else-if="item.isContinuing && item.startYear && !item.startMonth">{{ item.startYear}}년 〜 재직중</span>
              <span v-else-if="item.isContinuing && !item.startYear && item.startMonth">{{ item.startMonth }}월 〜 재직중</span>
              <span v-else-if="item.isContinuing && !item.startYear && !item.startMonth">재직중</span>
              <span v-else><template v-if="item.startYear">{{ item.startYear}}년</template> <template v-if="item.startMonth">{{ item.startMonth }}월</template>  <template v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{ item.endYear}}년</template> <template v-if="item.endMonth">{{ item.endMonth }}월</template></span>
            </h3>
            <!-- <h3>{{ item.companyName }}<span>{{ item.startYear}}년{{ item.startMonth }}월 〜 現在に至る</span></h3> -->
            <div class="organization" v-if="item.businessArea || item.numberOfEmployees || item.capitalStock" :style="formatData.selFontStyle">
              <p v-if="item.businessArea"><pre :style="formatData.selFontStyle">사업내용：{{ item.businessArea}}</pre></p>
              <p v-if="item.capitalStock && item.numberOfEmployees">자본금：{{ item.capitalStock }}만원、직원수：{{ item.numberOfEmployees }}명</p>
              <p v-else-if="item.capitalStock && !item.numberOfEmployees">자본금：{{ item.capitalStock }}만원</p>
              <p v-else-if="!item.capitalStock && item.numberOfEmployees">직원수：{{ item.numberOfEmployees }}명</p>
            </div>
            <h4 v-if="item.projects&&item.projects.length&&!formatData.notDisplayOmonajiseki">주요 실적</h4>
            <div v-for="(item, index) in item.projects"
                 :key="index" :style="formatData.selFontStyle">
              <h5 v-if="item.projectTitle || item.startYear || item.startMonth || item.endYear || item.endMonth">{{ item.projectTitle }}<span><template v-if="item.startYear">{{ item.startYear}}년</template> <template v-if="item.startMonth">{{ item.startMonth }}월</template> <template v-if="item.endYear || item.endMonth">〜</template> <template v-if="item.endYear">{{ item.endYear}}년</template> <template v-if="item.endMonth">{{ item.endMonth }}월</template></span></h5>
              <pre :style="formatData.selFontStyle">{{ item.contentsOfProject }}</pre>
            </div>
          </div>
        </div>

        <h2 v-if="formatData.prMessage">자기PR</h2>
        <div v-if="formatData.prMessage"
             class="prMessage"
             id="pr-message"
             :data-highlight="highlightMessage"
             @click="goCardTo('pr-message')"
             :class="highLightClass('pr-message')">
          <!-- <div class="label">{{ currentCardId }} {{ isCardChanged }}testtesttest</div> -->
          <pre :style="formatData.selFontStyle">{{ formatData.prMessage }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ShokurekishoPreviewMixin from '@/mixins/shokurekisho-preview-mixin'
export default {
  name: 'shokurekishoPreview',
  mixins: [ShokurekishoPreviewMixin],
  data: function () {
    return {}
  },
  methods: {
    checkValid: function () {
    }
  }
}
</script>
